var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5858_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0C11.7753 0 5.08398 6.69401 5.08398 14.9222C5.08398 27.1815 18.5155 39.1518 19.0875 39.6555C19.3395 39.8778 19.6641 40.0004 20.0002 40.0001C20.3263 40.0001 20.6522 39.8852 20.9131 39.6555C21.4848 39.1519 34.9164 27.1817 34.9164 14.9222C34.9164 6.69401 28.2251 0 20.0002 0ZM20.0002 36.7258C17.0307 33.8482 7.84627 24.1966 7.84627 14.9222C7.84627 8.21724 13.2985 2.76229 20.0002 2.76229C26.7019 2.76229 32.1542 8.21724 32.1542 14.9222C32.1542 24.1965 22.9698 33.8481 20.0002 36.7258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.97083C16.1925 7.97083 13.0947 11.0892 13.0947 14.9222C13.0947 18.7553 16.1925 21.8736 20.0003 21.8736C23.8081 21.8736 26.9059 18.7553 26.9059 14.9222C26.9059 11.0892 23.8081 7.97083 20.0003 7.97083ZM20.0003 19.1113C17.7156 19.1113 15.8569 17.2321 15.8569 14.9222C15.8569 12.6124 17.7156 10.7331 20.0003 10.7331C22.285 10.7331 24.1437 12.6123 24.1437 14.9222C24.1437 17.2321 22.285 19.1113 20.0003 19.1113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5858_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.3200c4b87319dbcad68214286b4498fb.svg";
export { ForwardRef as ReactComponent };